import React from 'react'

import TestProvider from '../../context/TestProvider.jsx'

import LandingTests from "../../Components/TesteTehnice/LandingTests/LandingTests.jsx"

function TesteTehnice() {
  return(
    <TestProvider>
      <LandingTests />
    </TestProvider>
  )
}

export default TesteTehnice
